export default __webpack_public_path__ + "static/media/logoformobile.d0ead76f.png";